module.exports = __webpack_public_path__ + "img/two1.3131be6b.png";